import { lazy, Suspense } from 'react';

import SearchEntryAuthGuard from '../components/AuthGuards/SearchEntryAuthGuard';
import RequirePermission from '../components/AuthGuards/RequirePermission';
import { COLLECTIONS_ENABLED } from '../api/collections/config';
import { PageName } from '../constants/routes.constants';

const CategoryCollection = lazy(() => import('../pages/CategoryCollection'));

// Registered only when the collections feature is on, the same idiom
// uploadRoutes.tsx uses for REACT_APP_ENABLE_UPLOAD: with the feature off there
// are no tiles to click, so there should be no page to reach either, and the
// rest of the app is byte-for-byte unaffected.
//
// WRAPPED IN SearchEntryAuthGuard, DELIBERATELY, and this is load bearing.
//
// The guard is what Home uses, and it is the reason useCollections needs no
// authInitialized gate: it renders null until auth has initialised and redirects
// an unauthenticated visitor to sign-in. Without it this route would sit outside
// every guard - the same position video-detail is in - and a fetch fired at
// mount could beat the Firebase session exchange and take a 401 that is never
// retried.
//
// Two reasons this route is guarded where video-detail is not: it shows the same
// licensable catalogue Home does and is only reachable FROM Home, and guarding
// removes the 401 race by construction rather than by remembering to add a gate
// inside the hook. If the guard is ever removed here, useCategoryVideos needs
// that gate added in the same change.
//
// The path takes a SLUG, not the category. 'TV/Film' contains a slash and would
// split into two path segments; api/collections/config.ts owns the single
// derived slug<->category mapping so the router and the API client cannot drift.
export const CollectionsRoutes = COLLECTIONS_ENABLED
  ? [
      {
        path: `${PageName.COLLECTIONS}/:slug`,
        // RequirePermission nests INSIDE the existing guard, same composition
        // as the home route: the outer guard keeps its unauthenticated
        // redirect contract, the inner one decides authenticated-but-denied.
        element: (
          <Suspense fallback={<></>}>
            <SearchEntryAuthGuard>
              <RequirePermission permission="search.own">
                <CategoryCollection />
              </RequirePermission>
            </SearchEntryAuthGuard>
          </Suspense>
        ),
      },
    ]
  : [];
